import { QueryClient } from "react-query";

// 앱 전역 React Query 클라이언트.
// 컴포넌트 밖(예: redux thunk)에서도 캐시 무효화를 호출할 수 있도록 모듈로 분리하여 export 한다.
// QueryClientProvider 에는 이 인스턴스를 그대로 전달한다(인스턴스 1개 유지).
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 5 * 60 * 1000, // 5분
    },
  },
});
